import { makeStyles } from '@mui/styles'
import {
  MIDNIGHT_EXPRESS,
  SHAMROCK,
  SLATE_GREY,
} from '@returnmates/client-core/src/constants/colors'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-block',
    width: 402,
    background: MIDNIGHT_EXPRESS,
    position: 'relative',
    overflow: 'hidden',
  },
  logoBackground: {
    width: 318,
    position: 'absolute',
    top: 'calc(50% - 47px)',
    right: 'calc(50% - 159px)',
    '& > *': {
      fill: 'rgba(255, 255, 255, 0.1)',
    },
  },
  imagePlant: {
    position: 'absolute',
    top: -10,
    left: -92,
  },
  imageShirt: {
    position: 'absolute',
    bottom: -230,
    left: -50,
  },
  imageStatue: {
    position: 'absolute',
    right: -50,
    bottom: 100,
    transform: 'scaleX(-1)',
  },
  imageChair: {
    position: 'absolute',
    bottom: 120,
    left: 0,
    width: 340,
  },
  imageGlasses: {
    position: 'absolute',
    top: 0,
    right: 20,
  },
  imageDumbbells: {
    position: 'absolute',
    top: 280,
    left: 0,
  },
  imageWindbreaker: {
    position: 'absolute',
    right: 0,
    top: 70,
  },
  signIn: {
    position: 'absolute',
    top: 24,
    right: 48,
  },
  logo: {
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '160%',
    color: SLATE_GREY,
  },
  link: {
    color: SHAMROCK,
  },
  '@media (max-width: 640px)': {
    root: {
      display: 'none',
    },
  },
}))

export default useStyles
